import React from 'react'
import About from '../components/About/About'
import Layout from '../Layout/Layout'

export default function aboutUs() {
    return (
        <Layout>
            <About />
        </Layout>
    )
}
